module.exports = __webpack_public_path__ + "static/06-243173f5cf546c062c5f1c1dab79b020.jpg";